import { aliasesList } from "../aliases-list";
import processAliasParameters from "./process-alias-parameters";

/**
 * Extract and replace aliases
 * @param {AliasVariantsProps} alias
 * @param {String} string
 * @param {String} extracted
 * @param {AliasProcessingProps} global
 * @returns {AliasProcessingProps}
 */
const replaceExtractedAlias = (alias, string, extracted, global) => {
  let result = new Map();
  const store = /** @type {Array<String>} */ ([]);

  /** Get alias definition from the `aliasesList` */
  const definition = /** @type {AliasDefinitionMapProps} */ (
    aliasesList.get(alias)
  );

  /** Get the "replacement" part of the definition represented by the `R` */
  const replacements = /** @type {AliasReplacementKeysProps} */ (
    definition.get("R") || []
  );

  /** Process given replacements */
  for (const replacement of replacements) {
    result = processAliasParameters(
      string,
      extracted,
      definition,
      replacement,
      store,
      global
    );
  }

  let index = 0;
  const results = result.get("result");

  /** In case no options was defined, remove the `<>` */
  for (const item of results) {
    if (item.includes("<>")) {
      results[index] = item.replace(/<>/g, "");
    }

    ++index;
  }

  return result;
};

export default replaceExtractedAlias;
